import dayjs from "dayjs";

/*
 * Visit Status modal (visitstatusmodal.jsx) helpers: the date v1 update-data
 * is sent, and the dashboard rows after a change it accepted.
 */

// Statuses v1's same-day sweep leaves alone (put_checkin _TERMINAL_STATUSES).
const TERMINAL = ["Checked Out", "Cancelled", "Rescheduled", "No Show"];

// The visit's own day, as v1 PUT checkin/patient/{pid}/update-data needs it:
// a day before today selects appointment_master_history (past visits live
// only there), and the same day scopes the server's check-in / check-out
// sweep of the patient's other appointments. Dashboard and search rows carry
// `startdate` ("YYYY-MM-DD HH:mm:ss"); the modal used to read `startDate`,
// which no row has, so it always sent today -- past-day changes came back
// 201 "No appointment found". No date at all still means today.
export function visitStatusDate(card) {
  const raw = card?.startdate || card?.startDate;
  const d = raw ? dayjs(raw) : null;
  return (d && d.isValid() ? d : dayjs()).format("YYYY-MM-DD");
}

// The dashboard rows once v1 accepted `status` for `card`'s appointment, as
// the server now has them, so the card updates at once (the background
// refresh covers today only, and every two minutes):
//  - the card's own row: visit_confirmation;
//  - every row of that patient whose allappts lists this appointment (the
//    patient's appointments that day -- the status chip and the Cancelled
//    border read them, not the row's own field): that entry;
//  - "Checked Out" on today or a later day: v1 also checks out the patient's
//    other open appointments that day (appointment_master only, so not on a
//    past day), and their entries and rows follow.
export function applyVisitStatus(rows, card, status) {
  if (!Array.isArray(rows) || !card) return rows;
  const apptId = String(card.appointmentid ?? "");
  const pid = String(card.patientid ?? "");
  const sweep =
    status === "Checked Out" && visitStatusDate(card) >= dayjs().format("YYYY-MM-DD");
  const isOpen = (s) => !TERMINAL.includes(s || "");
  const listsAppt = (item) =>
    Array.isArray(item?.allappts) &&
    item.allappts.some((a) => String(a?.appointmentid ?? "") === apptId);
  return rows.map((item) => {
    const own = item?.id === card.id;
    if (!own && !(String(item?.patientid ?? "") === pid && listsAppt(item))) return item;
    const next = { ...item };
    if (own || (sweep && isOpen(item.visit_confirmation))) next.visit_confirmation = status;
    if (Array.isArray(item.allappts)) {
      next.allappts = item.allappts.map((a) =>
        a && (String(a.appointmentid ?? "") === apptId || (sweep && isOpen(a.visit_confirmation)))
          ? { ...a, visit_confirmation: status }
          : a,
      );
    }
    return next;
  });
}
